module.exports = __webpack_public_path__ + "img/experience.379bff26.svg";